import React from 'react';
import { clientEntitlementsService } from '@services/client-entitlements.service.ts';
import { paymentService } from '@services/payment.service.ts';
import { PlanFeatureMatrix } from './PlanFeatureMatrix';

export const PlanFeatureMatrixTab: React.FC = () => (
  <PlanFeatureMatrix
    fetchPlans={() => paymentService.getAdminPlans(true)}
    fetchFeatures={() => clientEntitlementsService.listFeatures()}
    fetchPlanFeatures={(planId) => clientEntitlementsService.getPlanFeatures(planId)}
    setPlanFeatures={(planId, keys) => clientEntitlementsService.setPlanFeatures(planId, keys)}
  />
);
